<div class="chat_container container">
    <!--chat_sidebar-->
    <div class="col-sm-12 message_section">
        <div class="row">
            <div class="new_message_head">
                <h5>{{jobInfo?.title}}</h5>
            </div>
            <!--new_message_head-->

            <div class="chat_area" #scrollMe>
                <ul class="list-unstyled">
                    <li class="left clearfix" [ngClass]="m.from === 'candidate' ? 'admin_chat': null"
                        *ngFor="let m of messages">
                        <span class="chat-img1" [ngClass]="m.from === 'candidate' ? 'float-right':'float-left'">
                            <img [src]="m.from === 'candidate' ? candidateProfileInfo.photoPath : employerProfileInfo.photoPath"
                                alt="User Avatar" class="rounded-circle">
                            <div class="caption">
                                <p *ngIf="m.from === 'candidate'" class="d-flex justify-content-center">
                                    {{candidateProfileInfo.name}}</p>
                                <p *ngIf="m.from === 'employer'" class="d-flex justify-content-center">
                                    {{employerProfileInfo.name}}</p>
                            </div>
                        </span>

                        <div class="chat-body1 clearfix">
                            <span class="float-right download-link mb-3 mr-3" *ngIf="m.filePath"><a [routerLink]="" (click)="onDownloadClicked(m.filePath)">Download Attachment</a></span>
                            <p [innerHtml]="m.message"></p>
                            <span class="chat_time float-right mb-3 mr-3">{{m.time | date:'dd-MM-yyyy HH:mm:ss'}}</span>
                        </div>
                    </li>
                </ul>
            </div>
            <!--chat_area-->
            <div class="message_write">
                <textarea class="form-control" placeholder="Type a message" [(ngModel)]="chatText"
                    (keydown)="onKeyDown($event)"></textarea>
                <div class="clearfix"></div>
                <div class="chat_bottom">
                    <a [routerLink]="" class="float-right btn btn-md" (click)="onSendClick()">Send</a>
                    <app-upload
                        showIcon="true"
                        maxFileSizeInMb="2"
                        [acceptedFiles]="'.doc,.docx,.pdf,.jpg,.png,.m4v,.avi,.mpg,.mp4'"
                        (onUploadFinished)="uploadFinished($event)"></app-upload>

                        <span style="color: #ff8a00">{{uploadStatus}}</span>
                </div>
            </div>
        </div>
    </div>
    <!--message_section-->
</div>
